// extracted by mini-css-extract-plugin
export var header = "CustomizePanel_header__Etr2+";
export var mobile = "CustomizePanel_mobile__qniMg";
export var open = "CustomizePanel_open__VgRmL";
export var panelContainer = "CustomizePanel_panelContainer__FeOmm";
export var productGridWrapper = "CustomizePanel_productGridWrapper__6+isl";
export var productGridWrapperWithSidebar = "CustomizePanel_productGridWrapperWithSidebar__xnPSm";
export var status = "CustomizePanel_status__ZrjPI";
export var statusContainer = "CustomizePanel_statusContainer__KmOFX";
export var statusLight = "CustomizePanel_statusLight__s5oRQ";
export var title = "CustomizePanel_title__+sb0o";
export var toast = "CustomizePanel_toast__V3M5g";
export var toastBody = "CustomizePanel_toastBody__dPfae";
export var toastClose = "CustomizePanel_toastClose__ip50F";